import { useMemo } from 'react';

const hasScrollableOverflow = (element: HTMLElement): boolean => {
  const { overflowY } = window.getComputedStyle(element);
  return overflowY === 'auto' || overflowY === 'scroll';
};

const findScrollableAncestor = (element: HTMLElement): HTMLElement | null => {
  const candidates: HTMLElement[] = [];
  for (
    let current = element.parentElement;
    current;
    current = current.parentElement
  ) {
    if (!hasScrollableOverflow(current)) continue;
    if (current.scrollHeight > current.clientHeight) return current;
    candidates.push(current);
  }
  return candidates[0] ?? null;
};

export const useScrollableAncestor = (
  element: HTMLElement | null
): HTMLElement | null =>
  useMemo(() => (element ? findScrollableAncestor(element) : null), [element]);
